import React, { useEffect, Fragment } from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useHistory, useParams } from 'react-router-dom';
import {
  List,
  ListItem,
  ListItemText,
  Divider,
  Grid,
  ListItemSecondaryAction,
  IconButton,
} from '@material-ui/core';
import { CheckCircle as CheckCircleIcon, Cancel as CancelIcon } from '@material-ui/icons';
import { Amount, AppBar, Page, ScreenLoader } from 'components';
import { anketsStore, propertyStore } from 'stores';
import { ru } from 'locale';
import useStyles from './PropertyScreen.styles';

const amountFields = ['depositCost', 'marketPrice'];

const PropertyScreen = observer(() => {
  const classes = useStyles();
  const { propertyId } = useParams();
  const history = useHistory();
  const { fetchState, property } = propertyStore;

  useEffect(
    () =>
      autorun(() => {
        propertyStore.getProperty(anketsStore.anketId, propertyId);
      }),
    [propertyId],
  );

  const handleBackClick = () => {
    history.goBack();
  };

  const renderIcon = checked => {
    return checked ? (
      <CheckCircleIcon className={classes.iconCheck} />
    ) : (
      <CancelIcon className={classes.iconCancel} />
    );
  };

  const renderProperty = () => {
    const fields = Object.keys(property);

    return (
      <List aria-label={ru.property}>
        {fields.map((field, idx) => {
          const value = property[field];
          const showIcon = typeof value === 'boolean';
          const icon = showIcon ? null : value;
          const secondaryValue = amountFields.includes(field) ? (
            <Amount amount={{ value, currency: { code: 'RUR', minority: 0 } }} />
          ) : (
            icon
          );

          return (
            /* eslint-disable-next-line react/no-array-index-key */
            <Fragment key={idx}>
              <ListItem>
                <ListItemText primary={ru[field]} secondary={secondaryValue} />

                {showIcon && (
                  <ListItemSecondaryAction>
                    <IconButton edge="end">{renderIcon(value)}</IconButton>
                  </ListItemSecondaryAction>
                )}
              </ListItem>
              <Divider />
            </Fragment>
          );
        })}
      </List>
    );
  };

  return (
    <Page fullScreen style={{ minHeight: '100rvh' }}>
      <Grid container direction="column">
        <Grid item>
          <AppBar title={ru.property} onNavButtonClick={handleBackClick} />
        </Grid>

        {fetchState === 'pending' && <ScreenLoader />}
        {fetchState === 'fulfilled' && renderProperty()}
      </Grid>
    </Page>
  );
});

export default PropertyScreen;
